import SliderMobile from './SliderMobile'

export default SliderMobile
